module.exports = __webpack_public_path__ + "img/logo.77ea4341.png";